import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  TypingIndicator,
  Avatar,
} from "@chatscope/chat-ui-kit-react";

import React, { useState, useEffect } from "react";

export const NewChat = (props) => {
  const [lastPrompt, setLastPrompt] = useState("");

  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );
  useEffect(() => {
    if (props.recentPrompt !== lastPrompt) {
      handleSendRequest(props.recentPrompt);
      setLastPrompt(props.recentPrompt);
    }
  }, [props.recentPrompt, lastPrompt]);

  function clean_prompt(msg) {
    var div = document.createElement("div");
    div.innerHTML = msg;
    return div.textContent || div.innerText || "";
  }

  const handleSendRequest = async (raw_message) => {
    let message = clean_prompt(raw_message);

    var new_convo = {};
    new_convo["company"] = props.partnerMetadata.partner_name;
    // new_convo["conversation_name"] = message;
    new_convo["country"] = props.partnerMetadata.countries[0];
    new_convo["time"] = new Date();
    new_convo["history"] = [
      {
        message: message,
        sentTime: "just now",
        sender: profile.name,
        direction: "outgoing",
        country: props.partnerMetadata.countries[0],
      },
    ];
    new_convo["portco"] = props.partnerMetadata.partner_name;
    new_convo["partner_id"] = props.partnerMetadata.partner_id;

    localStorage.setItem("selectedReport_v2", JSON.stringify(new_convo));
    props.setSelectedReport(new_convo);
  };
  return (
    <div>
      <MainContainer
        style={{
          width: "100%",
          height: "100%",
          paddingRight: "0px",
          border: "none",
          paddingTop: "0px",
        }}
      >
        <ChatContainer
          style={{
            border: "none",
          }}
        >
          <MessageInput
            onSend={handleSendRequest}
            attachButton={false}
            placeholder={
              "Ask me about the " +
              props.partnerMetadata.partner_name.replace("_", " ") +
              " portfolio."
            }
          />
        </ChatContainer>
      </MainContainer>
    </div>
  );
};
export default NewChat;
